import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { PREMIUM_PAYS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateOrEditPremiumPay from './components/Form/CreateOrEditPremiumPay';
import useColumnDefinitions from './components/Table/hooks/useColumnDefinitions';
import useGetPremiumPaysTableData from './components/Table/hooks/useGetPremiumPaysTableData';

const PremiumPay = () => {
  const tableData = useGetPremiumPaysTableData();
  const columnDefinitions = useColumnDefinitions();
  const { mutate: handleDelete } = useDeleteById(PREMIUM_PAYS, ['premiumPays']);
  const { t } = useTranslation();
  
  return (
    <TableCRUDLayout
      FormComponent={CreateOrEditPremiumPay}
      rows={tableData}
      loading={isNil(tableData)}
      columns={columnDefinitions}
      getRowId={(row) => row.claBonusId}
      onDeleteClick={handleDelete}
      initialState={{
        sorting: {
          sortModel: [{ field: 'claBonusId', sort: 'asc' }]
        }
      }}
      columnVisibilityModel={{
        claBonusId: false
      }}
      confirmationTitle={t('premiumPays.deleteDialog.confirmationTitle')}
      confirmationBody={t('premiumPays.deleteDialog.confirmationBody')}
    />
  );
};

PremiumPay.displayName = 'PremiumPay';

export default PremiumPay;
